let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("b7bFd")).then(() => parcelRequire('3MhWk'));